const ExtraMoons = ({num, orbitcolor}) => {

  const extraMoonImages = [
    <circle fill={orbitcolor} strokeWidth="14px" cx="3558.15" cy="496.57" r="130.89"/>,

    <circle fill={orbitcolor} strokeWidth="14px" cx="2723.99" cy="3462.53" r="239.28"/>,

    <circle fill={orbitcolor} strokeWidth="14px" cx="452.03" cy="456.26" r="119.32"/>,

    <circle fill={orbitcolor} strokeWidth="14px" cx="2723.99" cy="3462.53" r="239.28"/>,

    <circle fill={orbitcolor} strokeWidth="14px" cx="1333.99" cy="3423.46" r="91.47"/>,

    <circle fill={orbitcolor} strokeWidth="14px" cx="3587.49" cy="627" r="59.35"/>,

    <g>
      <circle fill={orbitcolor} strokeWidth="14px" cx="1884.97" cy="3636.07" r="182.95"/>
      <circle fill={orbitcolor} strokeWidth="14px" cx="1333.99" cy="3423.46" r="91.47"/>
      <circle fill={orbitcolor} strokeWidth="14px" cx="373.36" cy="290.1" r="118.69"/>
      <circle fill={orbitcolor} strokeWidth="14px" cx="3587.49" cy="627" r="59.35"/>
    </g>,

    <g></g>,

    <g>
      <circle fill={orbitcolor} strokeWidth="14px" cx="2000.01" cy="284.64" r="138.28"/>
      <circle fill={orbitcolor} strokeWidth="14px" cx="2770.1" cy="432.69" r="69.14"/>
    </g>,

    <g></g>,
    
    <g></g>,

    <g></g>,
  ]

  const index = num - 1
  return extraMoonImages[index]
}

export default ExtraMoons
